export function getGreetingEndpoint(): string {
    return `/greeting`;
}
